module.exports = __webpack_public_path__ + "b7350427f5d9fbceabb3325336d69531.woff2";